

import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectDepartment from '@/components/Select/SelectDepartment.vue'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
@Component({
  components: {
    PublicTable,
    PublicQuery,
    SelectRegion,
    SelectDepartment,
  },
})
export default class StatsTable extends PublicTableView {
  protected queryItems: IFormItem[] = [
    {
      label: '选择日期',
      key: 'date',
      type: 'date',
      dateType: 'daterange',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  protected queryParams = {
    date: '',
    region: [],
    level: 0,
  }
  protected columns: ICol[] = [
    { label: '统计',
      prop: 'pathName',
    },
    { label: '自动开关',
      prop: 'sumTime',
      children: [
        { label: '手动次数', prop: 'n_auto_counts' },
        { label: '开关次数', prop: 'all_counts' },
        { label: '自动率', prop: 'auto_rate' },
      ] },
    { label: '使用总时间',
      prop: 'avgTime',
      children: [
        { label: '空调', prop: 'alltime_air' },
        { label: '灯光', prop: 'alltime_switch' },
        { label: '总计', prop: 'alltime' },
      ] },
    { label: '日平均工作时长',
      prop: 'devCount',
      children: [
        { label: '空调', prop: 'avg_air' },
        { label: '灯光', prop: 'avg_switch' },
      ] },
    { label: '节约率',
      prop: 'percent',
      children: [
        { label: '空调', prop: 'rate_air' },
        { label: '灯光', prop: 'rate_switch' },
        { label: '总计', prop: 'rate_all' },
      ] },
  ]
  @Watch('queryParams.level')
  private watchLevel() {
    this.queryParams.region = []
  }
  private handleSearch() {
    const { date = [], region = [], level = 0 } = this.queryParams || {}
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    this.onQuery(1)
  }
  private queryChange() {
  }
  protected queryMethod = api.getNetIdStatisticsData
  protected getQueryParams(params: any) {
    const { date = [], region = [], level = 0 } = params || {}
    console.log('region' + region)
    return {
      netId: region[region.length - 1],
      beginDay: date[0],
      endDay: date[1],
      workTime: '12',
      beginTime: '',
      endTime: '',
      invalidTimeBegin: '',
      invalidTimeEnd: '',
    }
  }
  protected processData(payload: any[]) {
    if (Array.isArray(payload)) {
      return payload.map((item: any) => {
        const { pathName = '', avgTime = {}, devCount = {}, percent = {}, sumTime = {} } = item || {}
        console.log('---------------' + JSON.stringify(item))
        return {
          pathName,
          n_auto_counts: item.手动次数 || '-',
          all_counts: item.所以控制次数 || '-',
          auto_rate: item.自动化率 || '-',
          alltime_air: item.空调使用时间 || '-',
          alltime_switch: item.开关使用时间 || '-',
          alltime: item.所有设备使用总时间 || '-',
          avg_air: item.空调平均时间 || '-',
          avg_switch: item.开关平均时间 || '-',
          rate_air: item.空调智能节约率 || '-',
          rate_switch: item.开关智能节约率 || '-',
          rate_all: item.所有设备节约率 || '-',
        }
      })
    } else {
      return []
    }
  }
}
